var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"background",attrs:{"data-menu-open":_vm.menuOpen},on:{"click":_vm.toggleMenu}}),_c('div',{staticClass:"menu",attrs:{"data-open":_vm.menuOpen}},[_c('Query',{attrs:{"query":_vm.query,"variables":{ languageIDs: _vm.languageIDs }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var languages = ref.languages;
return [_c('RecentlyViewedLanguages',{attrs:{"languages":[
            _vm.specialLanguages.all ].concat( languages,
            [_vm.specialLanguages.unknown]
          )}}),_c('AllLanguages',{attrs:{"languages":[
            _vm.specialLanguages.all ].concat( languages,
            [_vm.specialLanguages.unknown]
          )}})]}}])})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }